export default __webpack_public_path__ + "static/media/Logo CHUBB.58769cdc.svg";